import * as React from "react";
import { cls } from "@utdanningsdirektoratet/utils/cls";
import styles from "./DetailedList.module.less";

type DetailedListCellProps = {
  className?: string;
  size?: string;
  left?: boolean;
  center?: boolean;
  right?: boolean;
  bold?: boolean;
  style?: {
    [key: string]: string;
  };
  tooltip?: React.ReactNode | string;
  children?: React.ReactNode;
};

const DetailedListCell: React.FC<DetailedListCellProps> = ({ className, size, left, center, right, bold, children, style, tooltip }) => {
  const cellClass = cls(
    {
      [styles.detailedListCell]: true,
      [styles.detailedListCellLeft]: left,
      [styles.detailedListCellCenter]: center,
      [styles.detailedListCellRight]: right,
      [styles.detailedListCellBold]: bold,
      [styles.detailedListCellEllipsis]: tooltip === undefined,
    },
    className
  );
  let cellSize = "100%";
  if (size) {
    if (size.indexOf("%") > -1 || size.indexOf("px") > -1) {
      cellSize = size;
    } else {
      cellSize = `${size}px`;
    }
  }
  const cellStyle = {
    ...style,
    width: cellSize,
  };

  let content = children;
  if (tooltip) {
    const ellipsis = <div className={styles.detailedListCellEllipsis}>{children}</div>;
    content = React.cloneElement(tooltip as React.ReactElement, { children: ellipsis }, ellipsis);
  }
  return (
    <div className={cellClass} style={cellStyle}>
      {content}
    </div>
  );
};

export default DetailedListCell;
